.listItem {
  padding: 0;
}

.skeleton {
  margin-left: 4px;
}
